import st from './Footer.module.scss'
import footer from 'assets/images/footer.png'
import logo from 'assets/images/er-logo.svg'
import vk from 'assets/images/vk.svg'
import back_top from 'assets/images/back-top.svg'

export const Footer = ()=> {
    const scrollTop = ()=> window.scroll({ top: 0, behavior: 'smooth' })
    const fullYear = new Date().getFullYear()

    return (
        <footer className={st.footer}>
            <div className={st.ground}>
                <picture>
                    <img src={footer} alt="" width={100} height={100} />
                </picture>
            </div>
            <div className="wrapper">
                <div className={st.wrap}>
                    <a href="/" className={st.logo} target="_blank" rel="noopener noreferrer">
                        <img src={logo} alt="" width={110} height={28} />
                    </a>

                    <div className={st.bottom}>
                        <div className={st.left}>
                            <a href="https://vk.com/jd_er" className={st.vk} target={"_blank"} rel="noopener noreferrer">
                                <img src={vk} alt="" width={32} height={32} />
                            </a>
                            <p className={st.copy}>
                                Женское движение «ЕДИНОЙ РОССИИ»<br/>
                                ©{fullYear}, Партия «Единая Россия».<br/>
                                Все права защищены. <a href="https://er.ru/upages/privacy-policy" rel="noopener noreferrer" target="_blank">Политика конфиденциальности</a>
                            </p>
                        </div>

                        <div className={st.right}>
                            <p className={st.info}>
                                Продолжая находиться на данном сайте, вы соглашаетесь на предоставление информации
                                об ip-адресе, имени и стране домена провайдера, переходах с одной страницы на другую и cookies.
                            </p>
                            <button className={st.top} onClick={scrollTop}>
                                <span>Наверх</span>
                                <img src={back_top} alt="" width={32} height={32} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
